module.exports = __webpack_public_path__ + "static/media/small-closed-icon.310969ea.png";